// extracted by mini-css-extract-plugin
module.exports = {"container":"double-image_container__eigN2","mediaContainer":"double-image_mediaContainer__g4WTj"};